import { UserDetails } from '@ac/library-api';
import { createAction, getOneAction } from '@ac/library-utils/dist/redux-utils';

export const userLogin = getOneAction<undefined, boolean>('userLogin');
export const userDetails = getOneAction<undefined, UserDetails>('userDetails');
export const clearUserContext = createAction('clearUserContext');



// WEBPACK FOOTER //
// ./src/components/Login/domain/actions.ts